// extracted by mini-css-extract-plugin
export default {"root":"root-hnIMcp","backIcon":"backIcon-z65oOY","selected":"selected-_NHTu7","unselected":"unselected-zgjvWL","desc":"desc-Qbza7M"};